import { render, staticRenderFns } from "./img-box.vue?vue&type=template&id=1d7f0436&"
import script from "./img-box.vue?vue&type=script&lang=js&"
export * from "./img-box.vue?vue&type=script&lang=js&"
import style0 from "./img-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d7f0436')) {
      api.createRecord('1d7f0436', component.options)
    } else {
      api.reload('1d7f0436', component.options)
    }
    module.hot.accept("./img-box.vue?vue&type=template&id=1d7f0436&", function () {
      api.rerender('1d7f0436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/img-box.vue"
export default component.exports